export const healthIndicatorQuestionnaire = {
  digitalHeathQuestionnaire: "استبيان الصحة الرقمية",
  pdfTitle: "{country} - استبيان الصحة الرقمية",
  note: "سيتم عرض البيانات العالمية لمراقبة الصحة الرقمية علنًا. على هذا النحو ، يرجى الحصول على موافقة للتقديم من الوكالة الحكومية ذات الصلة (وزارة الصحة ، وكالة الصحة الرقمية ، إلخ) وتقديم معلومات الاتصال الخاصة بالموافق. ترك هذه الصفحة سيؤدي إلى تجاهل التغييرات غير المحفوظة.",
  contactForm: {
    contactInformation: "معلومات الاتصال",
    nameOfPersonEnteringData: "اسم الشخص الذي يدخل البيانات",
    roleOfThePersonEnteringData: "دور الشخص الذي يدخل البيانات",
    emailOfThePersonEnteringData: "البريد الإلكتروني للشخص الذي يدخل البيانات",
    nameOfTheApprover: "اسم الجهة المعتمدة للموافقة",
    roleOfTheApprover: "دور الجهة المعتمدة للموافقة",
    emailOfTheApprover: "البريد الإلكتروني للجهة المعتمدة للموافقة",
    nameOfTheCountryContact: "اسم جهة الاتصال بالبلد",
    roleOfTheCountryContact: "دور جهة الاتصال بالدولة",
    emailOfTheCountryContact: "البريد الإلكتروني لجهة الاتصال بالبلد",
    countrySummary: "ملخص البلد",
    organisationOfTheCountryContact: "المنظمة التي يتبع لها جهة الاتصال بالبلد",
    govtApprovedMessage: "هل البيانات معتمدة من الحكومة؟",

    error: {
      nameOfPersonEnteringData: "اسم الشخص الذي يدخل البيانات مطلوب",
      roleOfThePersonEnteringData: "مطلوب دور الشخص الذي يدخل البيانات",
      email: "يرجى إدخال البريد الإلكتروني الصحيح",
      nameOfTheApprover: "اسم الشخص الذي يوافق على البيانات مطلوب",
      roleOfTheApprover: "دور الشخص الذي يوافق على البيانات مطلوب",
      nameOfTheCountryContact: "الاتصال البلد هو مطلوب",
      roleOfTheCountryContact: "دور الاتصال البلد هو مطلوب",
      countrySummary: "ملخص البلد مطلوب",
      organisationOfTheCountryContact: "يرجى إدخال المنظمة",
    },
    hoverText: {
      nameOfPersonEnteringData: "الرجاء إدخال اسم الشخص الذي يدخل هذه البيانات",
      roleOfThePersonEnteringData: "يرجى إدخال دور الشخص الذي يدخل البيانات",
      email: "أدخل البريد الإلكتروني",
      nameOfTheApprover: "الرجاء إدخال اسم الشخص الذي يوافق على البيانات",
      roleOfTheApprover: "يرجى إدخال دور الشخص الذي يوافق على البيانات",
      nameOfTheCountryContact: "الاتصال البلد",
      roleOfTheCountryContact: "دور الاتصال البلد",
      organisationOfTheCountryContact: "أدخل منظمة الاتصال البلد",
    },
  },
  resourceForm: {
    resourceInformation: "معلومات الموارد",
    note: "يرجى تقديم روابط إلى الموارد ذات الصلة بالصحة الرقمية لبلدك.",
    exampleFormat: "مثال التنسيق: www.example.com",
    resource: "المصدر {number}",
    errorMessage: "الرجاء إدخال رابط ويب صالح للمورد",
  },
  notifications: {
    submit: "نموذج مقدم للمراجعة",
    saveCorrection: "تم حفظ النموذج بنجاح!",
    save: "تم حفظ النموذج بنجاح!",
    publish: "البيانات هي الآن على الهواء مباشرة",
    download: "بدأ التنزيل بنجاح",
    correctTheHighlightedFields: "اذا سمحت صحح الخانات المحدده.",
    somethingWentWrong: "لقد حدث خطأ ما. يرجى تحديث الصفحة!",
  },
  indicatorDetails: "تفاصيل المؤشر",
  indicatorScoreError: "مؤشر النتيجة والحقل المنطقي مطلوب.",
  rationaleOrSupportingText: "الأساس المنطقي أو النص الداعم",
  downloadPDF: "تحميل PDF",
  saveAsDraft: "حفظ كمسودة",
  submit: "خضع",
  save: "حفظ",
  reject: "رفض",
  publish: "نشر",
  republish: "إعادة النشر",
  confirm: "تؤكد",
  cancel: "إلغاء",
  note1: "سيتم عرض هذه التفاصيل علانية على منصة GDHM.",
  note2: "لن يتم عرض هذه التفاصيل على منصة GDHM وهي لأغراضنا الإعلامية.",
  note3: "سيتم عرض نقاط كل مؤشر علنًا فقط على منصة GDHM.",
  publishConfirmation:
    "أنت على وشك نشر نموذج فهرس الصحة الرقمية لـ {country}. هذا لا يمكن التراجع عنه. هل تريد الاستمرار؟",
  republishConfirmation:
    "أنت على وشك إعادة نشر نموذج فهرس الصحة الرقمي لـ {country}. لا يمكن التراجع عن هذا. هل تريد الاستمرار؟",
  saveConfirmation:
    "هل أنت متأكد أنك تريد إرسال البيانات الخاصة بـ {country}؟ يرجى التحقق من الخيارات التي حددتها والتي تعكس النضج الصحي الرقمي للدولة للعام الحالي",
  rejectConfirmation:
    "أنت على وشك رفض نموذج مؤشر الصحة لـ {country}. هذا لا يمكن التراجع عنه. هل تريد الاستمرار؟",
  govtApprovedMessage: "هل البيانات معتمدة من الحكومة؟",
  QuestionnaireStateMessage: {
    hasPrefillData:
      "تمت تعبئة البيانات مسبقًا في الاستبيان منذ عام {updatedDate}. يرجى تحديث بيانات العام الحالي وتقديم المبررات ذات الصلة",
    dataSubmittedAlready:
      "تم بالفعل إرسال البيانات الخاصة بالسنة الحالية بتاريخ {updatedDate}",
    dataPublishedAlready: "تم نشر بيانات العام الحالي بالفعل في {updatedDate}",
  },
};
